var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaugh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_1004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_1004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.694 -2.57375C87.7192 -1.63624 68.7872 17.628 67.8608 41.2013M152.239 18.9105C156.301 25.4203 158.774 33.0439 159.095 41.2598C160.081 66.4535 140.456 87.6757 115.262 88.6609C98.7447 89.3068 83.9346 81.094 75.415 68.261",
    stroke: "#FFC61B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.159 48.0838C143.169 47.503 142.056 46.9829 140.869 46.538C140.434 46.3747 139.989 46.2216 139.536 46.0793C136.242 45.044 132.548 44.5803 129.377 44.9586C127.735 45.1545 126.628 45.1245 125.971 44.9061C124.71 44.487 125.111 43.374 126.581 41.8333C132.174 35.9734 143.36 37.536 146.955 44.9586C147.693 46.4826 148.089 48.0038 147.629 48.6958",
    stroke: "#C7AAFA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0011 22.1992C92.914 22.1991 85.088 26.1122 81.6096 31.7644",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.711 38.3169C110.065 39.0656 110.329 39.7845 110.463 40.3871C110.601 41.0043 110.568 41.3433 110.522 41.4727C110.491 41.4776 110.435 41.4817 110.347 41.4739C109.954 41.4394 109.236 41.1998 108.086 40.5095C103.556 37.7917 96.8119 36.2313 91.3629 36.8962C90.0924 37.0512 89.1925 37.0659 88.5925 36.9888C88.2191 36.9409 88.0402 36.868 87.9641 36.8276C87.975 36.7773 88.0008 36.6955 88.0591 36.5726C88.2299 36.2126 88.5882 35.7181 89.1718 35.0928C91.9506 32.1154 96.1639 30.9829 100.193 31.5948C104.218 32.2063 107.921 34.5387 109.711 38.3169ZM87.9578 36.8934C87.9572 36.8936 87.9563 36.8894 87.9566 36.8798C87.9584 36.8883 87.9583 36.8931 87.9578 36.8934Z",
    stroke: "#C7AAFA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4344 54.3476C78.6952 63.9129 69.5649 66.5216 64.7822 61.3042C59.9996 56.0868 63.4779 48.2607 69.9997 45.652C75.2171 43.565 79.5649 42.1737 83.9126 39.1302C82.3697 42.8333 81.9019 45.4412 81.3082 49.1302",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.574 57.3913C130.444 58.2608 107.053 57.2173 86.5308 46.0869C84.8477 55.9751 88.0512 65.4561 94.4172 72.6087",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_1004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#FFC61B",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_1004",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_1004"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925 0 0 0 0 0.71256 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_1004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_1004",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaugh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laugh.0eb57a4abf63600d686a0fc65d1c5760.svg";